import { render, staticRenderFns } from "./PesquisaLegislacaoMunicipal.vue?vue&type=template&id=6e77fb0b&scoped=true"
import script from "./PesquisaLegislacaoMunicipal.vue?vue&type=script&lang=js"
export * from "./PesquisaLegislacaoMunicipal.vue?vue&type=script&lang=js"
import style0 from "./PesquisaLegislacaoMunicipal.vue?vue&type=style&index=0&id=6e77fb0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e77fb0b",
  null
  
)

export default component.exports